import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=78fa729f&scoped=true"
import script from "./VerifyPhone.vue?vue&type=script&lang=js"
export * from "./VerifyPhone.vue?vue&type=script&lang=js"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=78fa729f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa729f",
  null
  
)

export default component.exports